import { OrderProductItem } from "../orders.types";

export interface PackGroup {
  packGroupId: string;
  packId: string | null;
  packTitle: string | null;
  packPrice: number | null;
  packIsAvailable: boolean | null;
  rows: OrderProductItem[];
}

export type GroupedOrderItem =
  | { kind: "standalone"; item: OrderProductItem }
  | { kind: "pack"; group: PackGroup };

export const groupOrderItemsByPack = (
  items: OrderProductItem[]
): GroupedOrderItem[] => {
  const result: GroupedOrderItem[] = [];
  const groupsByPackId = new Map<string, PackGroup>();

  for (const item of items) {
    if (!item.packGroupId) {
      result.push({ kind: "standalone", item });
      continue;
    }

    let group = groupsByPackId.get(item.packGroupId);
    if (!group) {
      group = {
        packGroupId: item.packGroupId,
        packId: item.packId,
        packTitle: item.packTitle,
        packPrice: item.packPrice,
        packIsAvailable: item.packIsAvailable,
        rows: []
      };
      groupsByPackId.set(item.packGroupId, group);
      result.push({ kind: "pack", group });
    }

    group.rows.push(item);
  }

  return result;
};
